import ApplicationInfoStatus from "./application-info-status";

export default ApplicationInfoStatus;
